import { CommonModule } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterOutlet } from '@angular/router';
import { usePageTitleWithLangChange } from '@core/utils/page-title.util';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ToastContainerDirective, ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-root',
  imports: [
    RouterOutlet,
    CommonModule,
    FormsModule,
    ToastContainerDirective,
    TranslateModule,
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit {
  @ViewChild(ToastContainerDirective, { static: true })
  toastContainer!: ToastContainerDirective;

  private setPageTitle = usePageTitleWithLangChange();

  constructor(
    private toastr: ToastrService,
    private translate: TranslateService,
  ) {}
  ngOnInit(): void {
    this.toastr.overlayContainer = this.toastContainer;

    this.setPageTitle('app.title', 'Questback - Answer Module');

    this.translate.onLangChange.subscribe((event) => {
      document.documentElement.lang = event.lang;
    });
    document.documentElement.lang =
      this.translate.currentLang || this.translate.defaultLang || 'en';
  }
}
